import { render, staticRenderFns } from "./businesslicense.vue?vue&type=template&id=48ae9ee0&scoped=true&"
import script from "./businesslicense.vue?vue&type=script&lang=js&"
export * from "./businesslicense.vue?vue&type=script&lang=js&"
import style0 from "./businesslicense.vue?vue&type=style&index=0&id=48ae9ee0&lang=scss&scoped=true&"
import style1 from "./businesslicense.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./businesslicense.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ae9ee0",
  null
  
)

export default component.exports